var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSoldoutcart = function SvgSoldoutcart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.276 5.85-1.71 1.72-.57-.57 1.72-1.72-1.72-1.71.57-.57 1.71 1.72L15.996 3l.57.57-1.72 1.71L16.566 7l-.57.57-1.72-1.72Zm-7.42 4.48h8.11v.01l.64-1.83.76.26-.69 1.96c-.09.24-.32.4-.57.4h-8.01l.2.7h7.45c.22 0 .4.18.4.4 0 .22-.18.4-.4.4h-7.6c-.27 0-.51-.17-.58-.43l-1.76-6.07h-.01v-.04l-.35-1.21h-1.45c-.22 0-.4-.18-.4-.4 0-.22.18-.4.4-.4h1.59c.27 0 .51.17.58.43l.24.82h5.58v.8h-5.35l1.22 4.2Zm.64 4.17a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm.8 0c0 .25.2.45.45.45s.45-.2.45-.45-.2-.45-.45-.45-.45.2-.45.45Zm4.7-1.25a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm0 1.7c-.25 0-.45-.2-.45-.45s.2-.45.45-.45.45.2.45.45-.2.45-.45.45Z",
    fill: "currentColor"
  })));
};
export default SvgSoldoutcart;